import { useQuery } from '@tanstack/react-query'
import { mergeDeepRight, pathOr } from 'ramda'

import { useUrlParams } from '@/hooks'
import { AmplifyGraphQLclient } from '@/utils/amplify'
import {
  CustomComponent,
  ListCustomComponentsQueryVariables,
  Visibility,
} from '@/utils/api'

import { storeKey } from './CONSTANTS'

const getCustomComponent = /* GraphQL */ `
  query getCustomComponent(
    $id: ID!
    $filter: ModelCustomComponentFilterInput
    $nextToken: String
  ) {
    getOrganization(id: $id) {
      customComponents(filter: $filter, limit: 1000, nextToken: $nextToken) {
        nextToken
        items {
          name
          type
          id
          visibility
          updatedBy {
            email
            name
          }
        }
        __typename
      }
      __typename
    }
  }
`

export const useListCustomComponent = (
  orgID?: string,
  filter?: ListCustomComponentsQueryVariables['filter'],
  extraKey?: string[]
) => {
  const [{ archiveStatus = Visibility.active }] = useUrlParams()
  return useQuery({
    enabled: !!orgID,
    queryFn: async () => {
      const defaultFilter: ListCustomComponentsQueryVariables['filter'] = {
        visibility: { eq: archiveStatus as Visibility },
      }
      const req = await AmplifyGraphQLclient.graphql({
        query: getCustomComponent,
        variables: {
          filter: mergeDeepRight(defaultFilter, filter || {}),
          id: orgID,
        },
      })

      return (
        pathOr(
          [],
          ['data', 'getOrganization', 'customComponents', 'items'],
          req
        ) as CustomComponent[]
      ).sort((a, b) => {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
      })
    },

    queryKey: [storeKey, orgID, archiveStatus, ...(extraKey ?? [])],
  })
}
